export default async function GetProjectPlotByProjectId(projectId) {
    let url = window.RealestateService + `/api/ProjectPlotDetails/GetProjectPlotByProjectId?projectId=${projectId}`
    let head = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response
}